const inputClassname = "form-input ba br2 h-40 bg-white w-100";

export function formElemHasError(path, item) {
  try {
    const parts = path.split(".");
    const errorMessage = parts.reduce((obj, part) => obj[part], item);

    return errorMessage?.message?.length > 0;
  } catch (e) {
    return false;
  }
}

export default function getClassName(customClassname) {
  return (customClassname || inputClassname);
}